export default __webpack_public_path__ + "static/media/pig-silver-medal.e5ee7cd5.svg";